import {
  Box,
  Typography,
  List,
  ListItem,
  IconButton,
  Tooltip,
  Alert
} from '@mui/material';
import { Add as AddIcon } from '@mui/icons-material';

export default function MeetingsList({ meetings, selectedMeeting, onMeetingSelect, onAddMeeting, disableAdd }) {
  const formatDateFromTimestamp = (timestamp) => {
    // Check if timestamp is a Firestore Timestamp
    if (timestamp && timestamp.toDate) {
      return timestamp.toDate().toLocaleDateString();
    }
    // Handle regular Date objects
    if (timestamp instanceof Date) {
      return timestamp.toLocaleDateString();
    }
    // Handle timestamp as seconds
    if (typeof timestamp === 'number') {
      return new Date(timestamp * 1000).toLocaleDateString();
    }
    return 'Invalid date';
  };

  return (
    <Box sx={{
    }}>
      <Box sx={{
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
        mb: 2,
      }}>
        <Typography sx={{
          fontSize: '12px',
          color: '#666666',
          fontWeight: 500,
        }}>
          MEETINGS
        </Typography>
        <Tooltip
          title="Add a meeting"
          placement="top"
          TransitionProps={{ style: { transitionDuration: '0.15' } }}
          slotProps={{
            popper: {
              modifiers: [
                {
                  name: 'offset',
                  options: {
                    offset: [0, -10], // [x-offset, y-offset] in pixels
                  },
                },
              ],
            },
          }}
          componentsProps={{
            tooltip: {
              sx: {
                bgcolor: '#242424',
              }
            }
          }}
        >
          <IconButton
            onClick={() => onAddMeeting()}
            disabled={disableAdd}
            sx={{
              color: '#3366FF',
              p: 0.5,
              '&:hover': {
                bgcolor: 'rgba(51, 102, 255, 0.04)'
              },
              '&.Mui-disabled': {
                color: 'rgba(0, 0, 0, 0.26)',
                bgcolor: 'transparent'
              }
            }}
          >
            <AddIcon />
          </IconButton>
        </Tooltip>
      </Box>

      {meetings.length === 0 && !disableAdd && (
        <Alert severity="info" sx={{ mb: 2 }}>
          Add a meeting
        </Alert>
      )}

      {meetings.length === 0 ? (
        <Box sx={{
          p: 3,
          textAlign: 'center',
          display: 'flex',
          flexDirection: 'column',
          justifyContent: 'center',
          gap: 2
        }}>
          {/* <Typography variant="body2" color="text.secondary">
            No meetings found <br />
            Add a meeting
          </Typography> */}
        </Box>
      ) : (
        <List sx={{ pt: 0 }}>
          {meetings.map((meeting) => (
            <ListItem
              key={meeting.id}
              onClick={() => onMeetingSelect(meeting)}
              sx={{
                borderRadius: 2,
                mb: 1,
                cursor: 'pointer',
                bgcolor: meeting.id === selectedMeeting?.id ? '#FFFFFF' : 'transparent',
                border: '2px solid',
                borderColor: meeting.id === selectedMeeting?.id ? '#3366FF' : 'transparent',
                transition: 'all 0.2s ease',
                '&:hover': {
                  bgcolor: meeting.id === selectedMeeting?.id ? '#FFFFFF' : '#F0F0F0',
                },
                padding: '12px',
                display: 'flex',
                flexDirection: 'column',
                gap: '4px',
                alignItems: 'flex-start'
              }}
            >
              <Typography sx={{
                fontSize: '18px',
                fontWeight: 500,
                color: '#1A1A1A',
                whiteSpace: 'nowrap',
                overflow: 'hidden',
                textOverflow: 'ellipsis',
                width: '100%'  // Ensure the typography takes full width of its container
              }}>
                {meeting.displayDate}
              </Typography>
              <Typography sx={{
                fontSize: '12px',
                color: '#666666'
              }}>
                {formatDateFromTimestamp(meeting.date)}
              </Typography>
            </ListItem>
          ))}
        </List>
      )}
    </Box>
  );
}
